module.exports = __webpack_public_path__ + "img/realsam-logo-invisible.png";